export default __webpack_public_path__ + "static/media/spooky_hill_background_s2.b522d03a.jpg";